var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileGem = function SvgProfileGem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.455 3.839V1.545a.545.545 0 1 1 1.09 0v2.294a.545.545 0 1 1-1.09 0ZM8.182 4.264a.542.542 0 0 0 .77-.014.545.545 0 0 0-.014-.77L7.293 1.89a.544.544 0 1 0-.757.785l1.646 1.589ZM13.44 4.417c.136 0 .272-.051.378-.153l1.646-1.59a.545.545 0 0 0-.757-.783L13.062 3.48a.545.545 0 0 0 .378.937Z",
    stroke: "#FFF",
    strokeWidth: 0.1,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.872 10.403-3.463 4.108a.543.543 0 0 1-.767.065.545.545 0 0 1-.066-.767l2.708-3.212h-4.176l-3.454 9.051 3.464-4.11a.545.545 0 1 1 .833.703l-5.535 6.565a.545.545 0 0 1-.832 0L.128 10.403a.545.545 0 0 1-.01-.69L1.434 8.06a.544.544 0 1 1 .852.68l-.61.766h4.274L7.8 6.22H4.292l-.597.75a.544.544 0 1 1-.852-.68l.76-.954a.544.544 0 0 1 .427-.206h13.94c.166 0 .323.076.426.206l3.485 4.376a.545.545 0 0 1-.01.691Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.708 6.22H14.2l1.85 3.287h4.274zM7.2 9.507h7.6L12.95 6.22h-3.9zM1.716 10.597l7.63 9.051-3.453-9.051zM14.942 10.597H7.058L11 20.927z"
  }))));
};
export default SvgProfileGem;